/**
 * Loyalty tier + points chip shown in the AppShell top nav. Reads
 * `useLoyaltyBalance()`.
 */

import * as React from 'react';
import { Link } from 'wouter';

import { AnimatedNumber } from '@workspace/ui';
import { useLang, useT } from '../providers/LangProvider';
import { useLoyaltyBalance } from '../hooks/useLoyalty';
import { tierStyle } from '../lib/badges';

export function LoyaltyPill() {
  const t = useT();
  const [lang] = useLang();
  const { data, loading } = useLoyaltyBalance();
  const style = data ? tierStyle(data.tier) : null;

  return (
    <Link
      href="/loyalty"
      className="flex items-center gap-2 rounded-xl border border-neutral-200 bg-white px-3 py-1.5 text-sm text-neutral-700 hover:border-purple-400 hover:bg-purple-50 focus-visible:ring-2 focus-visible:ring-purple-500 focus-visible:ring-offset-2"
      aria-label={t.points}
    >
      <span aria-hidden="true">⭐</span>
      <span className="font-semibold text-neutral-900" aria-live="polite" aria-busy={loading}>
        {loading ? (
          t.walletLoading
        ) : data ? (
          <AnimatedNumber value={data.points} format={(n) => n.toLocaleString('ar-SA')} />
        ) : (
          t.walletError
        )}
      </span>
      {style && data && (
        <span
          className={`inline-block rounded-full px-1.5 py-0 text-[10px] font-semibold ${style.bg} ${style.text}`}
          aria-hidden="true"
        >
          {style.label[lang]}
        </span>
      )}
    </Link>
  );
}
